import React, { useEffect, useState } from "react";
import { format_time, formatDate } from "../Util/format_date";
import { translateWord } from "../Util/util";

export default function PosterInfo({ elem, noDesc }) {

    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = elem.image_title;

        img.onload = () => {
            setImageLoaded(true);
        }
        img.onerror = () => {
            setImageLoaded(false);
        }
    }, [elem.image_title]);
    return (
        <>
            <div className="title_poster">
                {imageLoaded ?
                    <div className="image_title" style={{ backgroundImage: `url('${elem.image_title}')` }}></div> :
                    <h1>{elem.movie_translation ? (elem.movie_translation.name || elem.name) : elem.name}</h1>
                }
            </div>
            <div className="date_movie">
                {/*{formatDate(new Date(elem.release_date),'yyyy')}*/}
                <p className={'release_date'}>{formatDate(new Date(elem.release_date), 'yyyy')}</p>
                <p className={'pg_info_field'}>{elem.pg ? '+' + elem.pg : translateWord('All')}</p>
                <p className={'hd_info_field'}>HD</p>
                {
                    !elem.canWatch && elem.content_monetization_type == 'tvod' ?
                        <div className="card_premium_movie">
                            <p>Premium</p>
                        </div>
                        : null
                }
                <p className={'serial_or_movie'}>{elem.type === 'movie' ? format_time(elem.duration * 60) : elem.season_count + ' Season'}{ }</p>

            </div>
            {
                noDesc ?
                    null :
                    <div className="description_movie">
                        {
                            elem.movie_translation ?
                                <p>{elem.movie_translation.description && elem.movie_translation.description.length > 320 ? elem.movie_translation.description.slice(0, 320) + ' . . .' : elem.movie_translation.description}</p> :
                                <p>{elem.description && elem.description.length > 320 ? elem.description.slice(0, 320) + ' . . .' : elem.description}</p>
                        }
                    </div>
            }

        </>
    )
}